import axios from 'axios';
import authHeader from './jwt-token-access/auth-token-header';

//apply base url for axios
const API_URL = process.env.REACT_APP_API_URL;
//const API_URL = 'http://localhost:5000/api';

const axiosApi = axios.create({
	baseURL: API_URL
});

axiosApi.interceptors.response.use(
	response => response,
	error => {
		if (error.response.status === 401 || error.response.status === 403) {
			localStorage.removeItem('authUser');
			window.location.href = '/login';
		}
		return Promise.reject(error);
	}
);

export async function get(url, config = {}) {
	//pass new generated access token here
	const token = authHeader();
	axiosApi.defaults.headers.common['customer-access-token'] = token;

	return await axiosApi.get(url, { ...config }).then(response => response.data);
}

export async function postWithFile(url, data, config = {}) {
	//pass new generated access token here
	const token = authHeader();
	axiosApi.defaults.headers.common['customer-access-token'] = token;
	return await axiosApi
		.post(url, data, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		})
		.then(response => response.data);
}

export async function post(url, data, config = {}) {
	//pass new generated access token here
	const token = authHeader();
	axiosApi.defaults.headers.common['customer-access-token'] = token;
	console.log('url', url);
	return axiosApi.post(url, { ...data }, { ...config }).then(response => response.data);
}

export async function put(url, data, config = {}) {
	//pass new generated access token here
	const token = authHeader();
	axiosApi.defaults.headers.common['customer-access-token'] = token;

	return axiosApi.put(url, { ...data }, { ...config }).then(response => response.data);
}

export async function del(url, config = {}) {
	//pass new generated access token here
	const token = authHeader();
	axiosApi.defaults.headers.common['customer-access-token'] = token;

	return await axiosApi.delete(url, { ...config }).then(response => response.data);
}
